export const GainLossRoles = {
    GAINLOSS_ADMIN : 'GainLossAdminRole',
    GAINLOSS_NORTHDATAENTRY : 'GainLossNorthDataEntryRole',
    GAINLOSS_SOUTHDATAENTRY : 'GainLossSouthDataEntryRole',
    GAINLOSS_NORTHDISTRICTSIGNOFF : 'GainLossNorthDistrictSignOffRole',
    GAINLOSS_SOUTHDISTRICTSIGNOFF : 'GainLossSouthDistrictSignOffRole',

};